// https://github.com/Nightapes/HumanizeDuration.ts
import { HumanizeDuration } from './human';

const service = new HumanizeDuration();

const MILISECONDS_IN_MINUTE = 60000;

export const humanizeToRussian = (minutes: number, options: Record<string, any> = { language: 'ru' }) => service.humanize(minutes * MILISECONDS_IN_MINUTE, options);
